import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { CampaignObject } from "../types/APITypes";
import { assertNotNull } from "../util/helpers/assert";


interface FormContextType {
    campaign: CampaignObject;
    setCampaign: (c : CampaignObject) => void;
}


const FormContext = createContext<FormContextType | null>(null);


export const useFormContext = () => assertNotNull(
    useContext(FormContext),
    "FormContext.useContext must be called from a child of FormContext.Provider"
)

export const Provider = ({children} : React.PropsWithChildren) => {

    const [campaign, setCampaign] = useState<CampaignObject>({} as CampaignObject);
    
    const providerValue = useMemo(() => ({
        campaign, setCampaign,
    }), [campaign]);
    
    return (
        <FormContext.Provider value={providerValue}>
            {children}
        </FormContext.Provider>
    )
} 